<template>
    <div class="text-gray-700 text-xs italic">
        <span class="text-red-700 ml-1" :title="$t('commons.required')">*</span>
        {{ $t('commons.required') }}
    </div>
</template>
<script>
export default {};
</script>
